<div *ngIf="transport">
  <jhi-bary-title titleClass="h3 bold text-dark" [title]="'track-and-trace-standalone.subTitle' | translate: { id: transport.id }"></jhi-bary-title>
  <jhi-transport-card [transport]="transport"></jhi-transport-card>
  <jhi-track-and-trace [transportOrder]="transport" [transporter]="transporter"></jhi-track-and-trace>
</div>
